import React from "react";
import { Box, Menu, MenuItem, Divider } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Unread from "../../../unread_projects_jobs/Unread";
import HeaderMenuItem from "./HeaderMenuItem";
import { FONT_SIZE } from "../../../../constants/fontSizes";

/**
 * 管理者用ヘッダー右側メニュー
 *
 * 右上のアイコンを押すと管理者メニューを表示する
 * - ユーザー一覧
 * - 企業登録
 * - お知らせ一覧
 * - ログアウト
 */
export default function AdminHeaderMenu({ unread, onClickLogout }) {
  const anchorRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen((v) => !v);
  const handleClose = () => setOpen(false);

  // 管理者メニュー
  const onAdminMenu = (path) => {
    handleClose();
    window.location.href = path;
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {/* 未読プロジェクト・求人 */}
      <Unread
        projectIndexUrl={unread?.projectIndexUrl}
        jobIndexUrl={unread?.jobIndexUrl}
        unreadProjects={unread?.unreadProjects || []}
        unreadJobs={unread?.unreadJobs || []}
        projectUnreadCount={unread?.projectUnreadCount || 0}
        jobUnreadCount={unread?.jobUnreadCount || 0}
      />

      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

      <Box sx={{ pr: 1 }}>
        {/* 管理者メニューを開くボタン */}
        <HeaderMenuItem
          ref={anchorRef}
          label="管理者"
          icon={<AccountCircleIcon />}
          onClick={handleOpen}
        />

        <Menu
          anchorEl={anchorRef.current}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            sx: {
              minWidth: 200,
              borderRadius: 2,
            },
          }}
        >
          <MenuItem
            sx={{
              fontSize: FONT_SIZE.SM,
              py: 1.2,
            }}
            onClick={() => onAdminMenu("/skill_sheets")}
          >
            マイページ
          </MenuItem>
          <MenuItem
            sx={{
              fontSize: FONT_SIZE.SM,
              py: 1.2,
            }}
            onClick={() => onAdminMenu("/admin_menu")}
          >
            ユーザー一覧
          </MenuItem>
          <MenuItem
            sx={{
              fontSize: FONT_SIZE.SM,
              py: 1.2,
            }}
            onClick={() => onAdminMenu("/admin/companies")}
          >
            企業一覧
          </MenuItem>
          <MenuItem
            sx={{
              fontSize: FONT_SIZE.SM,
              py: 1.2,
            }}
            onClick={() => onAdminMenu("/admin/notices")}
          >
            お知らせ一覧
          </MenuItem>

          <Divider />

          <MenuItem
            sx={{
              fontSize: FONT_SIZE.SM,
              py: 1.2,
            }}
            onClick={() => {
              handleClose();
              onClickLogout?.();
            }}
          >
            ログアウト
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
}
